// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 728) return "assortments.3d589ada866892b3a060.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"0d96a5bf84133e2929c8","34":"d9a78e3a641942347195","115":"fabb3b5bfc02f33b50e8","150":"6dcf165a7a176d91d8d0","178":"6c85992fd16cf1c19456","234":"01b803a9f0e14410c08a","441":"54aef6f76d5a0fab3e84","571":"4c102c33287e686c53e8","636":"e6ad9aa73da8ef7abeba","727":"c383616ee87cf7a14dd0","921":"ac1dfff3a8795a3a0ddd"}[chunkId] + ".css";
};